import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import api from "API/Api"
// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes"
import { apiError, loginSuccess, logoutUserSuccess } from "./actions"

//Include Both Helper File with needed methods
import { POST_LOGIN } from "../../../helpers/url_helper"
import { post } from "../../../helpers/api_helper"

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield post(POST_LOGIN, {
      email: user.email,
      password: user.password,
    })
    if (response.success === true) {
      localStorage.setItem("authUser", JSON.stringify(response.data))
      yield put(loginSuccess(response.data))
      history.push("/dashboard")
    } else {
      // Show the actual error message from the API
      yield put(apiError(response.message || "Invalid Email or Password"))
    }
  } catch (error) {
    // Extract meaningful error message
    let errorMsg = "Login failed. Please try again."
    if (error && error.message) {
      errorMsg = error.message
    } else if (error && error.response && error.response.data) {
      errorMsg = error.response.data.message || errorMsg
    } else if (typeof error === "string") {
      errorMsg = error
    }
    yield put(apiError(errorMsg))
  }
}
import { clearPermissionCache } from "API/UserAccess"

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")
    localStorage.removeItem("dairy_role")
    clearPermissionCache()
    history.push("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
